import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function parseCurrencyInputToCents(value: string | number | null | undefined): number | null {
  if (value === null || value === undefined || value === "") return null;

  const normalized = typeof value === "number"
    ? value
    : Number(value.replace(/[^0-9.]/g, ""));

  if (!Number.isFinite(normalized)) return null;

  return Math.round(normalized * 100);
}

export function formatUsdFromCents(
  cents: number | null | undefined,
  options?: Pick<Intl.NumberFormatOptions, "minimumFractionDigits" | "maximumFractionDigits">
) {
  if (cents === null || cents === undefined) return "";

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: options?.minimumFractionDigits ?? 0,
    maximumFractionDigits: options?.maximumFractionDigits ?? 2,
  }).format(cents / 100);
}
